module.exports = __webpack_public_path__ + "static/media/cookin-lab1000.a4422d30.gif";